export const ntpSettings = {
  ntp_primary: "ntp_primary_server",
};

export default ntpSettings;
